export default "__VITE_ASSET__be194399__"